import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import {
  primary01,
  shade0,
  shade300,
  shade700,
  shade800,
  shade950,
} from "../../styles/tokens";
import { normalStyles } from "../body/Body.Parts";

// TEXT

// STYLES
export const BorderBar = styled.div<{ $active?: boolean }>`
  z-index: 1;
  display: flex;
  height: 0.5rem;
  margin: 0 0.75rem;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  ${({ $active }) =>
    !$active
      ? css`
          border-bottom: 0.0625rem solid ${shade800};
        `
      : css`
          border-bottom: 0.125rem solid ${primary01};
        `}
`;

export const Content = styled.div`
  display: flex;
  padding: 0.5rem 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const Container = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: ${shade300};
  gap: 0;
  cursor: pointer;

  ${({ $active }) =>
    !$active
      ? css`
          cursor: pointer;
        `
      : css`
          color: ${shade0};
        `}

  &:disabled,
  &[disabled] {
    color: ${shade700};
    background: ${shade950};
    cursor: not-allowed;
  }

  ${normalStyles};

  &:hover:not(:disabled, [disabled]) {
    color: ${shade0};
  }

  &:focus-visible {
    outline: 1px solid ${shade0};
    outline-offset: 1px;
    box-shadow: 0 0 0 2px ${shade950};
  }
`;

// DATA

// TYPES
export type Props = React.ComponentPropsWithRef<"button"> & {
  $active?: boolean;
  label?: ReactNode;
  className?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
